<template>
  <div class="outlined-container"
       :class="{active: $props.active}">
    <div class="inner-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'outlined-container',
  props: {
    active: Boolean
  }
}
</script>

<style scoped lang="scss">
.outlined-container {
  width: 100%;
  display: block;
  padding: .2rem;
  -webkit-border-radius: 0.6rem;
  border-radius: 0.6rem;
  overflow: hidden;
  position: relative;
  transform: translate3d(0,0,0);

  &::before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, #b10d28, #cf1432 9%, #ed1a3b 25%, #f58220);
    transform: translate(-100%, -100%);
    transition: transform .3s ease-in-out;
  }

  &.active {
    &::before {
      transform: translate(0, 0);
    }

    .inner-container {
      background-color: $white;
    }
  }

  .inner-container {
    width: 100%;
    display: block;
    border-radius: 5px;
    position: relative;
    background-color: $grey;
    z-index: 0;
    transition: background-color .2s .1s;
  }
}
</style>
